import { useState } from 'react';

const checklist = [
  'Люди работают каждый сам по себе, а не как единая команда',
  'Между сотрудниками или отделами много конфликтов',
  'Новые сотрудники долго адаптируются и не чувствуют себя частью команды',
  'Отделы обвиняют друг друга в срыве сроков и ошибках',
  'Совещания проходят бесполезно — без решений и результатов',
  'Нет инициативы — сотрудники ждут указаний сверху',
  'Высокая текучесть — люди уходят из-за атмосферы',
  'Сложно внедрять изменения — встречают сопротивление и саботаж',
  'Культура «мы против них» между подразделениями',
  'Руководители тратят слишком много времени на разбор конфликтов',
];

export default function WhenToDevelop() {
  const [checked, setChecked] = useState<Record<number, boolean>>({});

  const toggleCheck = (i: number) => {
    setChecked(prev => ({ ...prev, [i]: !prev[i] }));
  };

  const checkedCount = Object.values(checked).filter(Boolean).length;

  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Когда компании пора заниматься развитием команды
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Не ждите кризиса. Честно отметьте утверждения ниже — самодиагностика покажет, насколько остро вашей компании нужно командообразование.
        </p>

        <div className="bg-white rounded-2xl p-8 md:p-12 border border-gray-200">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-10 h-10 bg-teal-600 rounded-lg flex items-center justify-center">
              <i className="ri-checkbox-multiple-line text-xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900">Чек-лист «Пора действовать»</h3>
          </div>

          <div className="bg-teal-50 border border-teal-200 rounded-xl p-6 mb-8 text-center">
            <span className="text-3xl font-extrabold text-teal-600">{checkedCount}</span>
            <span className="text-lg text-teal-700"> / {checklist.length} признаков проблем с командой</span>
            {checkedCount >= 3 && (
              <p className="text-teal-700 mt-2 font-semibold">
                Самое время заказать диагностику и разработать программу командообразования для вашей компании!
              </p>
            )}
          </div>

          <div className="space-y-3">
            {checklist.map((item, i) => (
              <button
                key={i}
                onClick={() => toggleCheck(i)}
                className={`w-full flex items-start gap-4 p-4 rounded-xl text-left transition-all cursor-pointer border ${
                  checked[i]
                    ? 'bg-teal-600 text-white border-teal-600'
                    : 'bg-gray-50 text-gray-700 border-gray-200 hover:border-teal-300'
                }`}
              >
                <div className={`w-6 h-6 rounded-md flex items-center justify-center flex-shrink-0 mt-0.5 transition-colors ${
                  checked[i] ? 'bg-white text-teal-600' : 'border-2 border-gray-300'
                }`}>
                  {checked[i] && <i className="ri-check-line font-bold"></i>}
                </div>
                <span className="text-sm md:text-base leading-relaxed">{item}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}